import React from "react"
import a23logo from '../assets/a23_avatar_logo.png'
import close from '../assets/close.png'
import { connect } from "react-redux";
import navarrow from "../assets/back_btn.png";
import { toggleModalAction, getUserProfileAction, getLinkAccountInfo, getWalletTypeInfo, getUPIInfo } from "../redux/actions/userAction";
import CircularProgress from "../Redeem/CircularProgress"
import Loading from "../models/Loading";
import { LINKWALLET_STRINGS, VERIFYUPI_STRINGS } from '../Strings'
import { WebToNativeMessage } from "../Common/Utils";
import Cross from '../assets/Redeem-revamp/Cross.svg'
import { isAndroid, isTablet } from "react-device-detect";
import { OtpInput, OtpInputWrapper, maxCharRestriction, onlyNumberInput } from '../Redeem/OTPInput';
import { notifyTokenReceived } from "../api/AxiosInstance"
import languageJson from '../OEMChanges/language.json';



class LinkWallet extends React.Component {
    constructor(props) {
        super(props)
        // console.log("What is the channel", languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"]);   
        const storedLang = window.sessionStorage.getItem("selectedLanguage") || "en";
        console.log("LinkWallet props", languageJson[storedLang]);
        
    
        this.elRefs = Array(6).fill(null).map(() => React.createRef());
        this.otpRef = React.createRef();
        this.otpInputRefs = [];

        this.state = {
            otp: ['', '', '', '', '', ''],
            isoemps: sessionStorage.getItem("channel") === "OEMAPS1" ? true: false,
            toShowErrorMessage: false,
            errors: {
                message: ""
            },
            loading: true,
            pageLoading: true,
            btntxt: `${VERIFYUPI_STRINGS.KEY_VERIFY_BTN_TV}`,
            isShowProgress: false,
            mobilenumber: window.sessionStorage["mobile"],
            resendotptoclick: false,
            token: window.sessionStorage["token"],
            otpfilled: false,
            channel: window.sessionStorage["channel"],
            toShowProgress: false,
            otpErrors: null,
            textProgress:60,
            resendotptoclick:false,
            bottom:'0%',
            value: {},
            //token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJmNTdmMzNmM2RmMjY5ZTZmMGI1OWNjNzg1NThmNmE1NyIsInN0YXR1cyI6dHJ1ZSwiZGV2aWNlX2lkIjoiNTAzMmQ3MzExZmY0YjkyIiwiaWF0IjoxNjI5MTg1MzgyLCJleHAiOjE2MjkyNzE3ODJ9.5XXsXBOEul-hCalR1S4Sq2xEvbSy9UXKMNj3i0bgXds"
        };
    }

    setElRefs = () => {
        this.elRefs = this.elRefs.map((ref, i) => ref || React.createRef());
      };

  componentDidMount() {
    this.updateTimer();
    this.setElRefs();
  }

  // componentWillMount(){
  //   clearInterval(this.state.intervalCode)
  // }
//   componentDidUpdate(prevProps, prevState) {
//     if (Object.values(this.state.value).join('').length === 6) {
//     //   this.otpRef.current.value = Object.values(this.state.value).join('');
//     //   this.setState({otp:Object.values(this.state.value).join('')})
//     //   this.setState({otpfilled:true})
//         this.setState({otpfilled:true})
//     }
//     else{
//         // this.setState({otp:Object.values(this.state.value).join('')})
//         this.setState({otpfilled:false})
//     }
    
//   }


  updateTimer = () => {
    console.log("update timer method called")
    let counter = 60;
    const interval = setInterval(() => {
      counter--;
      this.setState({
        textProgress: counter
      })
      if (this.state.textProgress === 0) {
        clearInterval(interval);
        this.setState({ textProgress: 0 })

        this.updateResendOtpVarFromTimer()
      }
    }, 1000);
  }

    onSubmit = async () => {
       
        // const { otp } = this.state;
        // otp=Object.values(otp).join('')
        let otp = Object.values(this.state.otp).join('')
        
        if (!otp) {
            this.setState({ errors: { message: `${LINKWALLET_STRINGS.KEY_OTP_EMPTY_TV}` } })
            this.setState({ toShowErrorMessage: true })
        } else if (otp.length < 4) {
            this.setState({ errors: { message: `${LINKWALLET_STRINGS.KEY_OTP_LENGTH_ERROR_TV}` } })
            this.setState({ toShowErrorMessage: true })
        } else {
            this.setState({ toShowProgress: true })
            if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` || this.props.walletType==='redeemRecommendation' || this.props.walletType==='redeem') {
                await this.props.getLinkAccountInfo(this.state.token, Object.values(this.state.otp).join(''), this.props.walletType==='redeem' ? "redeemPlacementOTP" : this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` ? "redeemAccountValidationOTP" : null)
            } else if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_UPI_TV}`) {
                await this.props.getUPIInfo("", "", Object.values(this.state.otp).join(''), "", false, this.state.channel)
            } else {
                if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_PAYTMWALLET_TV}`) {
                    await this.props.getWalletTypeInfo(this.state.token, `${LINKWALLET_STRINGS.KEY_PAYTM_TV}`, this.state.channel, Object.values(this.state.otp).join(''))
                } else {
                    await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, this.state.channel, Object.values(this.state.otp).join(''))
                }
                //await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, this.state.otp)
            }
            const { linkdata, wallettypedata, upidata } = this.props.userState
            if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` || this.props.walletType==='redeemRecommendation' || this.props.walletType==='redeem') {
                sessionStorage.setItem('walletresponse', JSON.stringify(""));
                if (linkdata.error) {
                    if(linkdata.error.statusCode===1123){
                        this.setState({ errors: { message: languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].invalidotp } })
                    }
                    else{
                        this.setState({ errors: { message: linkdata.error.message } })
                    }
                    this.setState({ toShowErrorMessage: true, toShowProgress: false })
                } else {
                    this.props.closePopUp()
                    this.props.openSelectedScreen(this.props.walletType)
                    if(this.props.walletType==='redeemRecommendation' || this.props.walletType==='redeem'){
                        // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage['aceLevel'],subscription_type: window.sessionStorage['subscriptionType']} })
                    }
                    else{
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemMode_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage['aceLevel'],subscription_type: window.sessionStorage['subscriptionType'],mode_selected:this.props.walletType} })
                    }
                    //sessionStorage.setItem('w_type', JSON.stringify("bankAccount"));
                }
            } else if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_UPI_TV}`) {
                if (upidata.error) {
                    if(upidata.error.statusCode===1123){
                        this.setState({ errors: { message: languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].invalidotp } })
                    }
                    else{
                        this.setState({ errors: { message: upidata.error.message } })
                    }
                    this.setState({ toShowErrorMessage: true, toShowProgress: false })
                } else {
                    window.sessionStorage["upitoken"] = upidata.token
                    this.props.closePopUp()
                    this.props.openSelectedScreen(this.props.walletType)
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemMode_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage['aceLevel'],subscription_type: window.sessionStorage['subscriptionType'],mode_selected:this.props.walletType} })


                }
            } else {
                if (wallettypedata.error) {
                    if(wallettypedata.error.statusCode===1123){
                        this.setState({ errors: { message: 'Invalid OTP' } })
                    }
                    else{
                        this.setState({ errors: { message: wallettypedata.error.message } })
                    }
                    this.setState({ toShowErrorMessage: true, toShowProgress: false })
                } else {
                    //sessionStorage.setItem('w_type', JSON.stringify("wallet"));

                    sessionStorage.setItem('walletresponse', JSON.stringify(wallettypedata.message));
                    sessionStorage.setItem('walletResponseStatusCode',JSON.stringify(wallettypedata.statusCode))
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "RedeemChange", eventProperties: { action: "Added", redeemOption: this.props.walletType, message: JSON.parse(sessionStorage.getItem('walletresponse')) } })
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemMode_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage['aceLevel'],subscription_type: window.sessionStorage['subscriptionType'],mode_selected:this.props.walletType} })
                    this.props.openSelectedScreen(this.props.walletType)
                    this.props.closePopUp()

                    //this.props.openSelectedScreen()
                }
            }
        }
    }

    handleInputChange = (event, index) => {
        const { value } = event.target;
        const newOTP = [...this.state.otp];
        newOTP[index] = value.replace(/[^0-9]/g, '').slice(0, 1);

        if (index < 5 && value !== '') {
            this.otpInputRefs[index + 1].focus();
        }

        this.setState({
            otp: newOTP,
            errors: {
                message: ""
            },
        });
    };

    handleBackspace = (event, index) => {
        if (event.keyCode === 8 && index > 0 && this.state.otp[index] === '') {
            this.otpInputRefs[index - 1].focus();
        }
    };

    handleInputClick = (index) => {
        if (Object.values(this.state.otp).join('').length === 6) {
            this.otpInputRefs[5].focus();
            this.otpInputRefs[5].setSelectionRange(
                this.otpInputRefs[5].value.length,
                this.otpInputRefs[5].value.length
            );
            return;
        }
        // Find the first unfilled input and focus on it
        for (let i = 0; i < this.state.otp.length; i++) {
            // if (this.state.otp[i] !== '') {
            //     this.otpInputRefs[i].setSelectionRange(
            //         this.otpInputRefs[i].value.length,
            //         this.otpInputRefs[i].value.length
            //     );
            // }
            if (this.state.otp[i] === '') {
                this.otpInputRefs[i].focus();
                break;
            }
        }
    };

    // onOtpInputChange = (elRefs, i) => {
    //     elRefs.current.value = onlyNumberInput(elRefs);
    //     maxCharRestriction(elRefs, 1);
    
    //     const inputValue = { ...this.state.value };
    //     if (!inputValue[i]) {
    //       inputValue[i] = elRefs.current.value;
    //     }
    
    //     this.setState({ value: inputValue });
    //     this.setState({otp:Object.values(this.state.value).join('')})
    //     console.log(this.state.value);
    //   };
    
    //   onBackspacePressHandler = (event, i) => {
    //     this.onOtpInputChange(this.elRefs[i], i);
    //     if (event.key === "Backspace") {
    //       if (i !== 0) {
    //         this.elRefs[i - 1].current.focus();
    //       }
    //       const { [i]: _, ...values } = this.state.value;
    //       this.setState({ value: values });
    //       this.setState({otp:Object.values(this.state.value).join('')})
    //     }
    //   };


    // handleInputChange = (event, index) => {
    //     const { value } = event.target;
    //     const newOTP = [...this.state.otp];
    //     newOTP[index] = value;

    //     if (index < 5 && value !== '') {
    //         this.otpInputRefs[index + 1].current.focus();
    //     }

    //     this.setState({ otp: newOTP });
    // };

    // handleBackspace = (event, index) => {
    //     if (event.keyCode === 8 && index > 0 && this.state.otp[index] === '') {
    //         this.otpInputRefs[index - 1].current.focus();
    //     }
    // };
    
      createOtpInputFields = () => {
        // let inputs = [];
        // const { otp } = this.state;
        // {otp.map((value, index) => (
        //     <OtpInput
        //         key={index}
        //         type="number"
        //         value={value}
        //         onChange={(event) => this.handleInputChange(event, index)}
        //         onKeyDown={(event) => this.handleBackspace(event, index)}
        //         ref={this.otpInputRefs[index]}
        //         maxLength="1"
        //     />
        // ))}
        // for (let i = 0; i < 6; i++) {
        //   inputs.push(
        //     <OtpInput
        //           key={index}
        //           type="text"
        //           value={value}
        //           onChange={(event) => this.handleInputChange(event, index)}
        //           onKeyDown={(event) => this.handleBackspace(event, index)}
        //           ref={this.otpInputRefs[index]}
        //           maxLength="1"
        //     />
        //   );
        // }
        return <OtpInputWrapper>
        {this.state.otp.map((digit, index) => (
            <OtpInput 
                isoemaps= {this.state.isoemps}
                key={index}
                type="tel"
                placeholder="."
                value={digit}
                // autocomplete="one-time-code"
                onFocus={() => {
                    isAndroid && this.setState({ bottom: '35%' });
                    if (this.state.otp[index] !== '') {
                        this.otpInputRefs[index].setSelectionRange(
                            this.otpInputRefs[index].value.length,
                            this.otpInputRefs[index].value.length
                        );
                    }
                }}
                onBlur={() => this.setState({ bottom: '0%' })}
                onChange={(e) => this.handleInputChange(e, index)}
                onKeyDown={(e) => this.handleBackspace(e, index)}
                onKeyUp={(evt)=>{
                    if(index===5){
                        if (evt.key === 'Enter') {
                            evt.target.blur();
                            if(Object.values(this.state.otp).join('').length===6 ){
                                this.onSubmit()
                            }    
                        }
                    }
                }}
                onPaste={(e) => {
                    e.preventDefault()
                    return false;
                  }} onCopy={(e) => {
                    e.preventDefault()
                    return false;
                  }}
                ref={(ref) => this.otpInputRefs.push(ref)}
                maxLength={1}
                onClick={() => {
                    this.handleInputClick(index);
                }}
            />
        ))}
    </OtpInputWrapper>;
      };
      
    onChange = e => {
        e.target.value = e.target.value.trim();
        if (e.target.name === "otp") {
            e.target.value = e.target.value.replace(/[^0-9 ]+/g, '')
            if (new RegExp(/^[0-9\b]+$/).test(e.target.value) || e.target.value === "") {
                if (e.target.value.length <= 6) {
                    this.setState({ [e.target.name]: e.target.value, otpfilled: true })
                }
                if (e.target.value.length === 0 || e.target.value.length <= 5) {
                    this.setState({ otpfilled: false })
                }
            }
        }

        else {
            this.setState({ [e.target.name]: e.target.value });
        }
    };

    //below method gets called from child CircularProgressbar class after the completion of timer.
    //enabling the click for resend otp after the completion of timer
    updateResendOtpVarFromTimer = () => {
        this.setState({ resendotptoclick: true, loading: false })
    }

    resendOTP = async () => {
        
        if (this.state.resendotptoclick) {
            
            this.setState({ resendotptoclick: false, otp: ['', '', '', '', '', ''], otpfilled: false,errors: { message: '' }})
            this.setState({
                pageLoading: true,
            })
            
            if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` || this.props.walletType==='redeemRecommendation' || this.props.walletType==='redeem') {
                await this.props.getLinkAccountInfo(this.state.token, "", this.props.walletType==='redeem' ? "redeemPlacementOTP" : this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` ? "redeemAccountValidationOTP" : null)
                const { linkdata } = this.props.userState
                if (linkdata.error) {
                    this.setState({
                        otpErrors: linkdata.error,
                    })
                }
            } else if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_UPI_TV}`) {
                await this.props.getUPIInfo("", "", "", "", false, this.state.channel)
                const { upidata } = this.props.userState
                if (upidata.error) {
                    this.setState({
                        otpErrors: upidata.error,
                    })
                }
            } else {
                if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_PAYTMWALLET_TV}`) {
                    await this.props.getWalletTypeInfo(this.state.token, `${LINKWALLET_STRINGS.KEY_PAYTM_TV}`, this.state.channel, "")
                    const { wallettypedata } = this.props.userState
                    if (wallettypedata.error) {
                        this.setState({
                            otpErrors: wallettypedata.error,
                        })
                    }
                } else {
                    await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, this.state.channel, "")
                    const { wallettypedata } = this.props.userState
                    if (wallettypedata.error) {
                        this.setState({
                            otpErrors: wallettypedata.error,
                        })
                    }
                }
                // await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, "")
            }
            this.setState({ loading: true,textProgress:60, toShowErrorMessage: false })
            this.otpInputRefs=[]
            this.updateTimer()

            this.setState({
                pageLoading: false,
            })
            WebToNativeMessage({type:'reactOTPRequest'})
        }
    }

    dataFromNative = (event) => {
        let date = new Date();
        console.log(`Message from Platform ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()} >>> ${event.data}`);
        let parsedMessage = JSON.parse(event.data)
    
    
      }

    async componentWillMount() {
        let otp=Object.values(this.state.otp).join('')
        console.log('came here sid',this.props.walletType)
        window.addEventListener("dataToClient", this.dataFromNative);
        WebToNativeMessage({type:'reactOTPRequest'})
        if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` || this.props.walletType==='redeemRecommendation' || this.props.walletType==='redeem' ) {
            // await this.props.getLinkAccountInfo(this.state.token, this.state.otp)
            await this.props.getLinkAccountInfo(this.state.token,otp, this.props.walletType==='redeem' ? "redeemPlacementOTP" : this.props.walletType === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` ? "redeemAccountValidationOTP" : null)
            const { linkdata } = this.props.userState
            if (linkdata.error) {
                this.setState({
                    otpErrors: linkdata.error,
                })
            }
        } else if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_UPI_TV}`) {
            await this.props.getUPIInfo("", "", "", "", false, this.state.channel)
            const { upidata } = this.props.userState
            if (upidata.error) {
                this.setState({
                    otpErrors: upidata.error,
                })
            }
        } else {
            if (this.props.walletType === `${LINKWALLET_STRINGS.KEY_PAYTMWALLET_TV}`) {
                // await this.props.getWalletTypeInfo(this.state.token, `${LINKWALLET_STRINGS.KEY_PAYTM_TV}`, this.state.channel, this.state.otp)
                await this.props.getWalletTypeInfo(this.state.token, `${LINKWALLET_STRINGS.KEY_PAYTM_TV}`, this.state.channel, otp)
                const { wallettypedata } = this.props.userState
                if (wallettypedata.error) {
                    this.setState({
                        otpErrors: wallettypedata.error,
                    })
                }
            } else {
                // await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, this.state.channel, this.state.otp)
                await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, this.state.channel, otp)
                const { wallettypedata } = this.props.userState
                if (wallettypedata.error) {
                    this.setState({
                        otpErrors: wallettypedata.error,
                    })
                }
            }
            //await this.props.getWalletTypeInfo(this.state.token, this.props.walletType, this.state.otp)
        }
        try {
            window.dataToClient = async (message) => {
              let parsedMessage = JSON.parse(message)
              if (parsedMessage.type && parsedMessage.type.toLowerCase() === "updatedtoken") {
                        console.log("Updated Token received from Native: ", parsedMessage.token);
                        let clientData = JSON.parse(window.sessionStorage.getItem("clientData"));
                        console.log("clientData before setting token: ", clientData);
                        if (clientData) {
                          clientData.token = parsedMessage.token;
                          clientData.a23Token = parsedMessage.a23Token;
                          console.log("setting clientData in sessionStorage: ", JSON.stringify(clientData));
                          window.sessionStorage.setItem("clientData", JSON.stringify(clientData))
                        }
                        window.sessionStorage.setItem("token", parsedMessage.token);
                        window.sessionStorage.setItem("a23token", parsedMessage.a23Token);
                        notifyTokenReceived(parsedMessage.token);
                        return;
                      }
              if(parsedMessage && parsedMessage?.type==='reactOTPAck'){
                this.setState({
                    otp: parsedMessage.data.split(''),
                    errors: {
                        message: ""
                    },
                });
              }
            }
        } catch (e) { }
        
        this.setState({
            pageLoading: false,
            toShowProgress:false
        })
    }



    onKeyUp = e => {
        if (e.key === 'Enter') {
            e.target.blur();
            Object.values(this.state.otp).join('').length===6 && this.onSubmit()
        }
    }

    handleCloseClick = (e) => {
        if (!this.state.toShowProgress) {
            sessionStorage.setItem('walletresponse', JSON.stringify(""));
            // this.props.toggleModalAction(false);
            this.props.closePopUp(e)
            this.setState({ toShowErrorMessage: false })
        }
    }


    render() {
        const { otp, otpfilled, resendotptoclick } = this.state;
        const { linkdata, wallettypedata, upidata } = this.props.userState;
        return (
            this.state.pageLoading ?
                <div style={{position:'absolute',width:'100%',height:"100%",background:'rgba(0,0,0,0.7)',pointerEvents:"none"}}>
                    <Loading />
                </div>
                :
                this.state.otpErrors ?
                    <div style={{ position:"absolute",width: "100%", height: "100%", display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                    <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen' onClick={() => this.handleCloseClick()}></div>

                        <div className="OTPLimitDiv" style={{ position: 'absolute', borderRadius: '10px', padding: '2.5rem 2rem 1rem 2rem' }}>
                            <div style={{ width: '50px', position: 'absolute', top: '-25px', left: '50%', transform: 'translate(-50%)' }}>
                                <img style={{ width: '100%' }} src={a23logo}></img>
                            </div>
                            <div className="infoTitle" style={{ textAlign: 'center', marginBottom: '12px' }}>
                                <span className="otpLimitText" style={{ fontWeight: 'bold', textAlign: 'center' }}>Error!</span>
                            </div>
                            {this.state.otpErrors.message}
                            <div className='btnDiv' style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                                <button className='addCashBtn btnStyle'
                                    onClick={() => { this.handleCloseClick() }}>
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                    :
                    // <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', maxWidth: '350px' }}>
                    //     <div className="relative absolute--fill flex justify-center items-center center tc br2 ph2 w7-l" >
                    //         <img className="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  z-9999 " src={a23logo} alt="no" ></img>
                    //         <img className="absolute top-1 right-1 w2" src={close} alt="no" onClick={() => this.handleCloseClick()}></img>
                    //         <div className="w-100 flex flex-column center ba pa1 br3 b--black-10 flex flex-column " style={{ backgroundColor: "#fffdea", color: "#032146", bordercolor: "#EABF6979", paddingTop: "1rem" }}
                    //         >
                    //             <div className="w-100 flex flex-column db pt2 mt3 pa1 center">

                    //                 <div className="w-100 db tc" >
                    //                     <h4 className=" mt0 mb0 fw10 f5 tc " style={{ color: "#032146" }}>{LINKWALLET_STRINGS.KEY_ENTER_OTP_TV}</h4>
                    //                     {this.state.loading && (<CircularProgress updateResendOtpVarFromTimer={() => this.updateResendOtpVarFromTimer()} ref="child" />)}
                    //                     {this.state.toShowErrorMessage && <div className="center mt2">
                    //                         <span className="red f7 ">{this.state.errors.message}</span>
                    //                     </div>
                    //                     }
                    //                     <p className="f7" style={{ color: "#032146" }}>{LINKWALLET_STRINGS.KEY_OTP_SEND_TV}</p>
                    //                     {this.state.mobilenumber !== "" && this.state.mobilenumber !== undefined && <div>
                    //                         <p style={{ color: "#032146" }}>{this.state.mobilenumber.substring(0, 5) + "xxxx" + this.state.mobilenumber.substring(9)}</p>
                    //                     </div>
                    //                     }
                    //                     {/* <form onSubmit={e=>{e.preventDefault();}} autoComplete="off"> */}
                    //                     <input type="tel" required value={otp} pattern="\d*" maxLength='6' onChange={this.onChange} onKeyUp={e => this.onKeyUp(e)} style={{ letterSpacing: otpfilled ? 8 : 0, color: "#032146" }} name="otp" id="otp" className="ml3 mr3 mt3 tc placeholder f4 fw4 w-80 bb bl-0 bt-0 br-0 b--silver bg-transparent outline-0 reset-input" placeholder={LINKWALLET_STRINGS.KEY_ENTER_OTP_TV} autoComplete="off" />
                    //                     {/* </form> */}

                    //                 </div>

                    //                 <p className=" f7 tc" style={{ color: resendotptoclick ? "#4a9bac" : "#4D032146" }} onClick={() => this.resendOTP()}>{LINKWALLET_STRINGS.KEY_RESEND_OTP_TV}</p>

                    //                 {this.state.toShowProgress && <div className="center">
                    //                     <Loading />
                    //                 </div>}
                    //                 <div className="flex justify-around center">
                    //                     {this.state.otpfilled ? (
                    //                         <button className="ph4 pv2 white br3 btn-green btn-green-login"

                    //                             onClick={async () => this.onSubmit()}>

                    //                             <p className="f8 mv0" style={{ color: "#fdfbea" }} >{LINKWALLET_STRINGS.KEY_CONFIRM_BTN_TV}</p>

                    //                         </button>) : (
                    //                         <button className="ph4 pv2 br3 bw0" style={{ backgroundColor: "#7F8485" }} disabled={true}

                    //                         >

                    //                             <p className="f8 mv0" style={{ color: "#fdfbea" }} >{LINKWALLET_STRINGS.KEY_CONFIRM_BTN_TV}</p>
                    //                         </button>
                    //                     )}
                    //                 </div>
                    //                 <div className="h1"></div>
                    //             </div>
                    //         </div>
                    //     </div>

                    // </div>
                    <div style={{ position: 'absolute', width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
                        <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen' onClick={() => {/**this.state.bottom==='0%' && this.handleCloseClick() */}}></div>
                        <div style={{ position: 'absolute', width: "100%", ...(isTablet ? {height: "50%"} : {height: "40%"}), color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center',bottom: this.state.bottom,transition:'bottom 300ms ease',background:"#f9f9f9",borderRadius:"5px 5px 0px 0px"  }} className='redeem-pop-up-animation-default'>
                            <div className="redeemAccountBottomSheet" style={{}}>
                                <div className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>{this.props.walletType === 'amazonPay' ? 'Amazon Pay Wallet' : this.props.walletType === 'paytmWallet' ? languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].paytmwallet : languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].enterotp}</div>
                                {this.props.walletType!=='redeem' ? 
                                <>
                                 <img id="Backbutton"src={navarrow} alt='close' style={{ position: 'absolute', left: '5%', width: '8%' }}  onClick={() => this.handleCloseClick('back')} />
                                 <img id="CloseIcon"src={Cross} alt='close' style={{ position: 'absolute', right: '5%'}}  onClick={() => this.handleCloseClick()} /> 
                                 </>
                                 :
                                 <img id="CloseIcon"src={Cross} alt='close' style={{ position: 'absolute', right: '5%'}}  onClick={() => this.handleCloseClick()} />    
                            }
                            </div>
                            {this.state.toShowProgress &&
                                <div style={{ position: "absolute", width: "100%", height: "100%", background: 'rgba(0,0,0,0.5)',pointerEvents:"none" }} onClick={(e)=>e.preventDefault()}>
                                    <Loading />
                                </div>
                            }
                            <div className="redeemAccountBottomDiv1" style={{  height: "60%", display: 'flex', alignItems: "center",justifyContent:'center', flexDirection: "column"}}>
                                <div className="redeemMethodSectionsText" style={{ width:"70%",textAlign:"center", fontSize: "0.9rem", fontWeight: "500"}}>{this.props.walletType === 'amazonPay' ? languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].linkyouramazonpaywalletwitha23 : this.props.walletType === 'paytmWallet' ? languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].linkyourpaytmwalletwitha23 : this.props.walletType==='redeem' ? languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].otpverificationismandatoryforsecuritypurposes : ''}</div>
                                <div className="OTPText" style={{fontSize: "0.9rem", fontWeight: "500", marginTop: "5%" }}>
                                    {LINKWALLET_STRINGS.KEY_OTP_SEND_TV}
                                    {this.state.mobilenumber !== "" && this.state.mobilenumber !== undefined && <span className="OTPMobile" style={{fontWeight:"700"}}>{this.state.mobilenumber.substring(0, 5) + "xxxx" + this.state.mobilenumber.substring(9)}</span>}
                                </div>
                                <div className="inputFieldData" id="otpmessageentry"style={{ width: "75%", height: "20%", display: 'flex', alignItems: "center", marginTop: "4%",paddingBottom:'2%' }}>
                                    {/**                                    <input onFocus={()=>this.setState({bottom:"25%"})} onBlur={()=> isAndroid && this.setState({bottom:'0%'})} style={{ width: "100%", height: "95%", background: "transparent",letterSpacing: otpfilled ? 8 : 0, color: "#032146"  }} type="tel" required value={otp} pattern="\d*" maxLength='6' onChange={this.onChange} onKeyUp={e => this.onKeyUp(e)} name="otp" id="otp" className="ml3 mr3 mt3 tc placeholder f4 fw4 w-80 bb bl-0 bt-0 br-0 b--silver bg-transparent outline-0 reset-input" placeholder={LINKWALLET_STRINGS.KEY_ENTER_OTP_TV} autoComplete="off" />
 */}
                                    {this.createOtpInputFields()}
                                </div>
                                <div className="colorRedOEM" style={{  width: "75%",marginTop:'2%' }}>{this.state.errors.message}</div>
                                <div style={{ width: '75%', display: 'flex', alignItems: 'center',fontSize:'0.9rem', justifyContent: 'center',marginTop:"2%" }}>
                                    
                                    {(this.state.loading && this.state.textProgress !== 0 && !resendotptoclick) ?
                                        <div className="resendOTPText" style={{ width: "100%", textAlign: 'center' }}>{languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].resendotpin} {this.state.textProgress + 's'}</div>
                                        :
                                        <div id = "resendOtpLink"onClick={() => resendotptoclick && this.resendOTP()} style={{ color: "#58B6C6", textAlign: 'center', textDecoration: "underline" }}>{languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].resendotp}</div>
                                    }
                                    {/**                    <div style={{ width: "75%",display:"flex",alignItems:'center',justifyContent:'center',...(enableResend ? {color:"rgb(25, 106, 41)"} : {color:"#707070"})}} onClick={()=>{enableResend && verifyEmail(true);updateTimer();setEnableResend(false);setEmailVerifyOtp('')}}>Resend OTP</div>
 */}
                                </div>
                                {/**{(this.state.loading && this.state.textProgress !== 0) && <div>Resend OTP in {this.state.textProgress + 's'}</div>}
                                {this.state.toShowErrorMessage && <div style={{ color: "#C62828", width: "75%" }}>{this.state.errors.message}</div>}
                                <p className=" f7 tc" style={{ color: resendotptoclick ? "#4a9bac" : "#4D032146" }} onClick={() => this.resendOTP()}>{LINKWALLET_STRINGS.KEY_RESEND_OTP_TV}</p>
 */}
                                
                            </div>

                            <div className="redeemSelectionDiv" style={{ width: "100%", height: "25%", display: 'flex', alignItems: "center",flexDirection:'column', ...(this.props.walletType==='redeem' ? {justifyContent:'space-evenly'} : {justifyContent:'center'}) }} >
                                {this.props.walletType==='redeem' ? <>
                                
                  
                                <div id = "verifybutton"className= {(Object.values(this.state.otp).join('').length===6 ? this.state.isoemps ? "redeemSelectionTextYellow" :  "redeemSelectionTextGreen" : "redeemSelectionTextGrey")} onClick={
                                    async ()=>{
                                        Object.values(this.state.otp).join('').length===6 && this.onSubmit()
                                        this.props.handleCTEvent('Verify')
                                    }
                                } style={{ width: "90%", height: "50%" , borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>{(this.props.walletType==='amazonPay' || this.props.walletType==='paytmWallet') ? 'Link Account' : 'Verify'}</div>
                                
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '30%', color: "#196A29",color:"#58B6C6", fontSize: '0.85rem', fontWeight: '700' }}  >
                                     <span onClick={() => {
                                        this.props.handleCTEvent('Back to Lobby')
                                    WebToNativeMessage({ type: "goToLobby" });
                                  }} style={{borderBottom:"1px solid #58b6c6",paddingBottom:"1%"}}>{languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].backtolobby}</span></div>
                                
                                </> :
                            
                                <>
                                
                                <div id = "verifybutton"className= { (Object.values(this.state.otp).join('').length===6 ? this.state.isoemps ? "redeemSelectionTextYellow" :  "redeemSelectionTextGreen" : "redeemSelectionTextGrey")} onClick={
                                    async ()=>{
                                        Object.values(this.state.otp).join('').length===6 && this.onSubmit()
                                    }
                                } style={{ width: "90%", height: "60%" , borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>{(this.props.walletType==='amazonPay' || this.props.walletType==='paytmWallet') ? languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].linkaccount : languageJson[window.sessionStorage.getItem("selectedLanguage") || "en"].verify}</div>

                                </>}
                            </div>
                        </div>
                    </div>
        )
    }
}

const mapStateToProps = state => ({
    userState: state.userState,
    linkdata: state.linkdata
});

export default connect(mapStateToProps, { toggleModalAction, getUserProfileAction, getLinkAccountInfo, getWalletTypeInfo, getUPIInfo })(LinkWallet);